import {
  type CanvasElementId,
  type CanvasElementProperties,
  type StyleConfigProps,
  type VisibilityElementProps,
  type WithColumns,
  type WithIoConfig,
  type WithProps,
} from '@blaze-runtime/engine-domain';
import {
  type CanvasElementPropertiesWithData,
  type ElementSizingMode,
  type ExpressionObj,
  type PropertiesConfigInputBackground,
  type PropertiesConfigInputSpacingAndAlignmentModel,
} from '@blaze-shared/elements-domain';

export const CONTAINER_INITIAL_SLOT_ID = '0';

export const CONTAINER_DEFAULT_HEIGHT = 48;
export const CONTAINER_MAX_HEIGHT = 1000;
export const CONTAINER_HEIGHT_OPTIONS: ElementSizingMode[] = ['min'];

export const SIDEBAR_CONTAINER_DEFAULT_WIDTH = 160;

type PropsModel = CanvasElementPropertiesWithData & StyleConfigProps & VisibilityElementProps;

export type BaseContainerDef<T extends CanvasElementProperties> = WithColumns &
  WithProps<T> &
  WithIoConfig;

export type BaseContainerPropsModel = PropsModel & {
  // Used in slots visibility only.
  // For now slot props are taken from main element.
  // TODO: [MG] When typings for slot props are added adjust container props.
  content?: {
    visibilityExpression?: ExpressionObj[];
  };
  wrapper?: {
    mainElementId: CanvasElementId;
  };
  style: {
    container: PropertiesConfigInputBackground & {
      offset: PropertiesConfigInputSpacingAndAlignmentModel;
    };
  };
};
